import script from "./AudiosDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudiosDetailsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9bef53"]])

export default __exports__